<template>
  <div class="what-app-chat">
    <div class="what-app-chat__header">
      <button
        type="button"
        v-on:click="onClose"
        title="Вернуться назад"
        class="what-app-chat__header__exit" />
      <div class="what-app-chat__header__user">
        {{ name }}
      </div>
    </div>
    <div ref='messages' class="what-app-chat__messages">
      <whats-app-message
        v-for='message in initialMessages'
        v-bind:key='message.id'
        v-bind:class='["message", { right: message.isMine }]'
        v-bind:text='message.text'
        v-bind:author='message.from'
        v-bind:quoted-message="message.quotedMessage"
        v-bind:is-mine="message.isMine"
        v-bind:download-url="message.downloadUrl"
        v-bind:file-name="message.fileName"
        v-bind:type="message.type"
        v-bind:options="message.options"
        v-on:reply="replyMessage(message)"
        v-on:delete="onDeleteMessage(message.id)"
        v-on:forward="onForwardMessage(message.id)"
      />
    </div>
    <whats-app-chat-box
      class="what-app-chat__chat"
      v-bind:quoted-message="quotedMessage"
      v-on:remove-quoted-message="removeQuotedMessage"
      v-on:submit="onSendMessage"
    />
  </div>
</template>

<script>
import WhatsAppMessage from '@/components/WhatsAppMessage.vue';
import WhatsAppChatBox from '@/components/WhatsAppChatBox.vue';
import debounce from 'lodash.debounce';

/**
 * @description Название события отправки сообщения.
 * @type {string}
 */
const NAME_EVENT_SEND_MESSAGE = 'send-message';

/**
 * @description Название события закрытия чата.
 * @type {string}
 */
const NAME_EVENT_CLOSE_CHAT = 'close';
/**
 * @description Название события удаления чата.
 * @type {string}
 */
const NAME_EVENT_DELETE_MESSAGE = 'delete-message';

/**
 * @description Название события пересылки сообщений.
 * @type {string}
 */
const NAME_EVENT_FORWARD_MASSAGE = 'forward-message';

/**
 * @description Компонент Whats App чата.
 * @type {Vue}
 */
export default {
  components: { WhatsAppChatBox, WhatsAppMessage },
  data() {
    return {
      quotedMessage: null,
    };
  },
  created() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.$refs.messages.scrollTop = this.$refs.messages.scrollHeight;
      }, 0);
    });
  },
  name: 'WhatsAppChat',
  methods: {
    /**
     * @description Событие отправки сообщения.
     * @returns {void}
     */
    onSendMessage(text, file) {
      const quotedMessageId = this.quotedMessage === null ? '' : this.quotedMessage.id;
      this.$emit(NAME_EVENT_SEND_MESSAGE, text, quotedMessageId, file);
      this.quotedMessage = null;
    },
    /**
     * @description Событие закрытия чата.
     * @returns {void}
     */
    onClose() {
      this.$emit(NAME_EVENT_CLOSE_CHAT);
    },
    /**
     * @description Событие удаления сообщения.
     * @param {string} messageId
     * @returns {void}
     */
    onDeleteMessage(messageId) {
      this.$emit(NAME_EVENT_DELETE_MESSAGE, messageId);
    },
    /**
     * @description Событие пересылки сообщения.
     * @param {string} messageId
     * @returns {void}
     */
    onForwardMessage(messageId) {
      this.$emit(NAME_EVENT_FORWARD_MASSAGE, messageId);
    },
    /**
     * @description Ответ на сообщение.
     * @param message
     */
    replyMessage(message) {
      this.quotedMessage = {
        id: message.id,
        text: message.text,
        author: message.from,
      };
    },
    /**
     * @description Убрать цитируемое сообщение.
     * @returns {void}
     */
    removeQuotedMessage() {
      this.quotedMessage = null;
    },
  },
  props: {
    /**
     * @description Начальные сообщения.
     * @type {Array}
     */
    initialMessages: {
      default: () => [],
      type: Array,
    },
    /**
     * @description Название чата.
     * @type {String}
     */
    name: {
      required: true,
      type: String,
    },
  },
  watch: {
    initialMessages: debounce(
      function fetch() {
        this.$refs.messages.scrollTop = this.$refs.messages.scrollHeight;
      },
      0,
    ),
  },
};
</script>

<style scoped lang="scss">
.what-app-chat {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  margin: -22px 27px 0 -27px;
  max-width: 800px;
  width: 800px;
  height: 100vh;
  position: relative;
  &__header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    background-color: #EAEFF3;
    width: 100%;
    padding: 20px 30px 25px 28px;
    z-index: 1;
    position: fixed;
    &__exit {
      background-image: url("@/assets/img/exit-black.svg");
      background-position: center;
      width: 20px;
      height: 20px;
    }
    &__user {
      color: #192A3E;
      font-size: 20px;
      line-height: 24px;
      font-weight: 600;
    }
  }
  &__messages {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 25px 43px 30px 60px;
    margin: 70px 0 0 0;
    height: calc(100vh - 300px);
    overflow: auto;
  }
}
@media screen and (max-width: 860px) {
  .what-app-chat {
    max-width: 100%;
    width: 100%;
    margin: 0;
    &__header {
      z-index: 3;
    }
    &__messages {
      padding: 25px 20px 30px 20px;
    }
  }
}
@media screen and (max-width: 860px) {
  .what-app-chat {
    &__header {
      padding: 15px 10px;
    }
  }
}
</style>
